<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="done-check"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path id="Path_8495" data-name="Path 8495" d="M0,0H18V18H0Z" fill="none" />
    <path
      id="Path_8496"
      data-name="Path 8496"
      d="M9.75,16.5h0A6.75,6.75,0,0,1,3,9.75H3A6.75,6.75,0,0,1,9.75,3h0A6.75,6.75,0,0,1,16.5,9.75h0A6.75,6.75,0,0,1,9.75,16.5Z"
      transform="translate(-0.75 -0.75)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8497"
      data-name="Path 8497"
      d="M14,10l-3.75,3.75L8,11.5"
      transform="translate(-2 -2.5)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
<style scoped>
path {
  transition: all 0.5s ease-out 0.5s;
}
</style>
